import { render, staticRenderFns } from "./SearchMailbox.vue?vue&type=template&id=2abf48c0&scoped=true&"
import script from "./SearchMailbox.vue?vue&type=script&lang=js&"
export * from "./SearchMailbox.vue?vue&type=script&lang=js&"
import style0 from "./SearchMailbox.vue?vue&type=style&index=0&id=2abf48c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abf48c0",
  null
  
)

export default component.exports